<template>
    <div id="app">
        <loading ref="loading"></loading>
        <keep-alive v-if="$route.meta.keepAlive">
            <router-view></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>
<script>

import Vue from 'vue';
import Element from 'element-ui';
import loading from '@/components/loading';
import {MTA_SERVER} from './config/index'
import MtaH5 from 'mta-h5-analysis';

Vue.use(Element);

export default {
    name: 'app',
    components: {
        loading
    },
    data(){
      return {

      }
    },
    methods: {
    },
    created() {
        MtaH5.init({
          "sid": MTA_SERVER.sid, //必填，统计用的appid
          "cid": MTA_SERVER.cid, //如果开启自定义事件，此项目为必填，否则不填
          "autoReport":0,//是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
          "senseHash":1, //hash锚点是否进入url统计
          "senseQuery":0, //url参数是否进入url统计
          "performanceMonitor":1,//是否开启性能监控
          "ignoreParams":[] //开启url参数上报时，可忽略部分参数拼接上报
        });
        MtaH5.pgv();
    },
    mounted(){
        window.history.replaceState(null,"",null)

        if(document.getElementById("loading").style.display === 'block') {
            this.$refs.loading.isLoading = false;
        } else {
            this.$refs.loading.isLoading = true;
        }
    }
}
</script>

<style scope lang="sass">
html ,body
  @font-face
    font-family: FZLTHJW_0;
    src: url("/src/assets/font/FZLTHJW_0.ttf");
  font-family: FZLTHJW_0;
  .main-container
    overflow: hidden;
</style>


// WEBPACK FOOTER //
// src/App.vue